import React from "react";

export const useSound = (url: string) => {
  const audioRef = React.useRef(new Audio(url));

  const play = () => {
    audioRef.current.currentTime = 0;
    audioRef.current
      .play()
      .catch((err) => console.log("Erro ao tocar som:", err));
  };

  return play;
};
